export const menuOptionsPublisher = {
  arxiv: "arXiv",
  cvpr: "CVPR",
  neurips: "NeurIPS",
  mlsys: "MLSys"
};
